import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Timeline, TimelineLite} from "gsap"
import {SymbolUtil} from "../../../utils/SymbolUtil";
import {DirtyWildGameModuleConfig} from "../../DirtyWildGameModuleConfig";
import {DirtyWildsGameConfig} from "../../DirtyWildsGameConfig";
import {DirtyWildsSoundConfig} from "../../DirtyWildsSoundConfig";
import {DirtyWildsParsedGameData, WildSymbolData} from "../../server/data/DirtyWildsParsedGameData";
import {DirtyWildsStateReelSymbol, DirtyWildsSymbols} from "../../symbols/DirtyWildsStateReelSymbol";
import {DirtyWildGameMode} from "../DirtyWildsRespinZeroBetController";


/**
 * Class description
 *
 * Created: 2018-05-02
 * @author jonas
 */
export class DirtyWildsOverlayReelStopController extends ReelStopPresentationController {
    private _mode:string;
    private _nextMode:string;
    private _isFirstSticky:boolean;
    private _positionsWildInfo:WildSymbolData[];
    private _targetSpins:number;
    private _beforeStopSpinsRemaining:number;
    private _afterStopSpinsRemaining:number;
    private _afterStopMultiplier:number;
    private _stoppedReels:boolean[];
    private _reelsData:string[][];
    private _isRandomFeatureTriggered:boolean;
    private _hasTransitioned:boolean;

    constructor(index:number, name:string) {
        super(index, name);
    }


    protected hasWin() {
        return this._mode == DirtyWildGameMode.STICKY_RESPIN || this._nextMode == DirtyWildGameMode.STICKY_RESPIN;
    }

    protected resetFeature():void {
        this._targetSpins = 0;
        this._stoppedReels = [false, false, false, false, false];
    }

    protected parseFeatureGameData(data:ParsedGameData):void {
        this._hasTransitioned = false;
        this._mode = data.mode;
        this._nextMode = data.nextMode;

        this._reelsData = data.reels;

        this._positionsWildInfo = (<DirtyWildsParsedGameData>data).positionsWildInfo;
        this._beforeStopSpinsRemaining = (<DirtyWildsParsedGameData>data).beforeStopSpinsRemaining;
        this._afterStopSpinsRemaining = (<DirtyWildsParsedGameData>data).afterStopSpinsRemaining;
        this._targetSpins = this._beforeStopSpinsRemaining;
        this._isRandomFeatureTriggered = (<DirtyWildsParsedGameData>data).isRandomFeatureTriggered;
        this._afterStopMultiplier = (<DirtyWildsParsedGameData>data).afterStopMultiplier;

        //State related
        this._isFirstSticky = this._mode == DirtyWildGameMode.NORMAL && this._nextMode == DirtyWildGameMode.STICKY_RESPIN;
    }


    public getNewOverlaysForReel(reelId:number):WildSymbolData[] {
        const overlays:WildSymbolData[] = [];
        for(let overlay of this._positionsWildInfo) {
            if(overlay.wildPosition[0] == reelId && overlay.isNewWild) {
                overlays.push(overlay);
            }
        }
        return overlays;
    }

    private addOverlayBackToReel(reelId:number):void {
        const symCol:number[] = [0, 1, 2];

        for(let i = 0; i < symCol.length; i++) {
            let reelOverlaysWOW = this._positionsWildInfo.filter((a, b) => {return (a.wildPosition[0] === reelId && a.wildPosition[1] === symCol[i])});
            let centerPoistion = [2, 1];
            let isDoubleWild:boolean = (reelOverlaysWOW.length > 0 && reelOverlaysWOW[0].wildPosition !== centerPoistion) ? reelOverlaysWOW[0].isDoubleWild : false;
            DirtyWildGameModuleConfig.overlayController.addOverlayBackInReel([reelId, symCol[i]], isDoubleWild);
        }
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(data.reelId === 0 || data.reelId === 4) {
            return;
        }


        const newOverlays:WildSymbolData[] = this.getNewOverlaysForReel(data.reelId);
        if(newOverlays.length > 0 && !this._isRandomFeatureTriggered) {
            if(this._isFirstSticky && !this._hasTransitioned) {
                DirtyWildGameModuleConfig.effectManager.getChangeBackgroundAnimation(DirtyWildGameMode.STICKY_RESPIN, 1.5);
            }
            let isMiddleSymbol:boolean = newOverlays.filter((a) => { return a.wildPosition[0] === 2 && a.wildPosition[1] === 1}).length > 0;
            if(!isMiddleSymbol || (newOverlays.length > 1 && isMiddleSymbol)) {
                SlotGame.sound.playEffect(DirtyWildsSoundConfig.WILD_LAND_BOUNCE);
                SlotGame.sound.playEffect(DirtyWildsSoundConfig.WILD_LAND);
            }
        }
    }


    public getLandingAttention(overlays:WildSymbolData[]):TimelineLite {
        const tl = new TimelineLite();
        for(let overlay of overlays) {
            const symbolInReel:string = this._reelsData[overlay.wildPosition[0]][overlay.wildPosition[1]];

            if(symbolInReel != DirtyWildsSymbols.W) {
                continue;
            }
            let symbol = Reels.getSymbol(overlay.wildPosition[0], overlay.wildPosition[1]);
            tl.add(SymbolUtil.getSymbolStateAnimations([symbol!], DirtyWildsGameConfig.instance.SYMBOL_STATES.wildLand)[0], 0);
        }
        return tl;
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(!this.hasWin()) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }
        const tl:TimelineLite = new TimelineLite({
            onComplete : () => {
                this.dispatchCompleteEvent(data.reelId);
            }
        });
        this._stoppedReels[data.reelId] = true;
        const newOverlays:WildSymbolData[] = this.getNewOverlaysForReel(data.reelId);
        this.addOverlayBackToReel(data.reelId);
        if(newOverlays.length > 0) {
            tl.add(this.getLandingAttention(newOverlays));
        }

        if(this.allReelsStopped()) {
            this._hasTransitioned = true;

            if(this._isFirstSticky) {
                //Run intro
                this._isFirstSticky = false;
                tl.set({}, {}, tl.totalDuration());
                if(!this._isRandomFeatureTriggered) {
                    tl.add(() => DirtyWildGameModuleConfig.soundPlayer.switchToFreespinMusic());
                }
                this.initiateWildAnimation(tl, this._isRandomFeatureTriggered ? 0.6 : 0);
            } else {
                this.initiateWildAnimation(tl, 0, true);
            }
        }
    }

    private allReelsStopped():boolean {

        for(let reel of this._stoppedReels) {
            if(!reel) {
                return false;
            }
        }
        return true;
    }

    public getMultiplierUpdate(overlay:WildSymbolData):TimelineLite {
        const targetMultiplier = Math.floor(overlay.multiplierIndexAfter / 3) + 1;
        const tl = new TimelineLite();
        tl.add([
            DirtyWildGameModuleConfig.topBarView.addMultiplier(overlay.multiplierIndexAfter, targetMultiplier, overlay.wildPosition, overlay.isDoubleWild)
        ]);
        return tl;
    }


    public getFirespinUpdate(overlay:WildSymbolData):TimelineLite {
        this._targetSpins += overlay.addedSpins;
        const tl = new TimelineLite();
        tl.add(DirtyWildGameModuleConfig.topBarView.addSpins(this._targetSpins, overlay.wildPosition));
        return tl;
    }

    private getSymbolLandingAttention(position:[number, number], animName:ISymbolStateConfig):Timeline {
        let symbol = Reels.getSymbol(position[0], position[1]);
        return SymbolUtil.getSymbolStateAnimations([symbol!], animName)[0];
    }

    public animateWildSymbols(newTl:TimelineLite, animName:ISymbolStateConfig, isRespinState:boolean, initialPosition:number):void {
        let tlPosition:number = initialPosition;
        for(let i = 0; i < this._positionsWildInfo.length; i++) {
            let overlay = this._positionsWildInfo[i];
            let removeOldSymbol:boolean = false;
            let isMiddleSymbol:boolean = (overlay.wildPosition[0] === 2 && overlay.wildPosition[1] === 1);
            if(overlay && ((!isMiddleSymbol && isRespinState) || !isRespinState)) {
                const oldSymbol = <DirtyWildsStateReelSymbol>Reels.getSymbol(overlay.wildPosition[0], overlay.wildPosition[1]);
                let symbol = Reels.getSymbol(overlay.wildPosition[0], overlay.wildPosition[1]);
                let newWildTl:TimelineLite = new TimelineLite();
                newWildTl.addLabel('targetZero', 0);
                newWildTl.addLabel('targetPointFive', 0.2);
                if(oldSymbol!.symName != DirtyWildsSymbols.W) {
                    (<DirtyWildsStateReelSymbol>oldSymbol).replaceWithNewSymbolInReel(DirtyWildsSymbols.W, false, DirtyWildsGameConfig.instance.SYMBOL_STATES.sticky);
                    symbol = Reels.getSymbol(overlay.wildPosition[0], overlay.wildPosition[1]);
                    if(symbol) {
                        symbol.visible = false;
                        newWildTl.add(() => symbol!.visible = true);
                        removeOldSymbol = true;
                    }
                }
                if(symbol) {
                    let multiPosition:number = 0.5;
                    const targetMultiplier = Math.floor(overlay.multiplierIndexAfter / 3) + 1;
                    newWildTl.add(this.getSymbolLandingAttention(overlay.wildPosition, animName), 'targetZero');
                    removeOldSymbol ? newWildTl.add(() => oldSymbol!.deleteSelf()) : "";

                    if(animName === DirtyWildsGameConfig.instance.SYMBOL_STATES.attention) {
                        multiPosition = ((overlay.multiplierIndexAfter % 3) === 1 && targetMultiplier > 1) ? 1.2 : 0.5;
                        newWildTl.add(this.getMultiplierUpdate(overlay), 'targetPointFive');
                        newWildTl.add(() => SlotGame.sound.playEffect(DirtyWildsSoundConfig.WILD_HIGHLIGHT), 0);
                    } else {
                        newWildTl.add(this.getFirespinUpdate(overlay), 'targetPointFive');
                        newWildTl.add(() => SlotGame.sound.playEffect(DirtyWildsSoundConfig.WILD_EXPLOSION), 0);
                    }
                    tlPosition += (i == 0 ? 0 : multiPosition);
                    newTl.add(newWildTl, tlPosition, "start", 0.1);
                }
            }
        }
    }

    private initiateWildAnimation(tl:TimelineLite, initialPosition:number, isRespinState:boolean = false):void {
        this.animateWildSymbols(tl, DirtyWildsGameConfig.instance.SYMBOL_STATES.ignite, isRespinState, initialPosition);
        this.animateWildSymbols(tl, DirtyWildsGameConfig.instance.SYMBOL_STATES.attention, isRespinState, tl.totalDuration() - 0.5);
        tl.add(() => SlotGame.keypad.setZeroBetSpinCounter(this._afterStopSpinsRemaining), tl.totalDuration() - 0.5);
    }
}